import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";
import { useReachFreqStore } from "@/stores/ReachStore";
import { useTaskStore } from "@/stores/TaskStore";
import { useErrorStore } from "@/stores/ErrorStore";

export const ReachAndFrequencyStores = [
  useMetaAudienceStore,
  useReachFreqStore,
  useErrorStore,
];

export const ReachAndFrequencyChannel = {
  async received(payload) {
    if (await this.reachFreqStore.handleExportMessage(payload)) {
      return;
    }
    if (payload.status === "error" || payload.data?.status === "error") {
      const task = Object.keys(this.reachFreqStore.taskIds).find(
        (task) => this.reachFreqStore.taskIds[task] === payload.id,
      );
      if (task) {
        this.reachFreqStore.taskIds[task] = undefined;
        this.reachFreqStore.loading[task] = false;
        if (task in this.reachFreqStore.errors) {
          this.reachFreqStore.errors[task] = payload.message;
          if (task === "exposureOverview") {
            this.reachFreqStore.exposureOverview = undefined;
            this.reachFreqStore.exposureMarkets = undefined;
            this.reachFreqStore.marketBreakdown = undefined;
            this.reachFreqStore.errors.marketBreakdown = undefined;
          }
        } else {
          this.errorStore.showError(payload.message);
        }
      }
      return;
    }
    if (payload.id === this.reachFreqStore.taskIds.dateRange) {
      this.reachFreqStore.loading.dateRange = false;
      this.reachFreqStore.dates = {
        minDate: payload.data.dates.min_date
          ? new Date(payload.data.dates.min_date).toISOString()
          : undefined,
        maxDate: payload.data.dates.max_date
          ? new Date(payload.data.dates.max_date).toISOString()
          : undefined,
      };
      this.reachFreqStore.taskIds.dateRange = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.races) {
      this.reachFreqStore.loading.races = false;
      this.reachFreqStore.races = payload.data;
      this.reachFreqStore.taskIds.races = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.sponsors) {
      this.reachFreqStore.loading.sponsors = false;
      this.reachFreqStore.sponsors = payload.data;
      this.reachFreqStore.taskIds.sponsors = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.networkStations) {
      this.reachFreqStore.loading.networkStations = false;
      this.reachFreqStore.networkStations = payload.data;
      this.reachFreqStore.taskIds.networkStations = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.creatives) {
      this.reachFreqStore.loading.creatives = false;
      this.reachFreqStore.creatives = payload.data;
      this.reachFreqStore.taskIds.creatives = undefined;
      if (this.reachFreqStore.filters.creative_ids?.length) {
        this.reachFreqStore.filters.creative_ids =
          this.reachFreqStore.filters.creative_ids
            ?.map((creative_id) => {
              if (
                this.reachFreqStore.creatives.find((c) => c.id === creative_id)
              ) {
                return creative_id;
              }
            })
            .filter((i) => i !== undefined);
      }
    }
    if (payload.id === this.reachFreqStore.taskIds.reachMetrics) {
      this.reachFreqStore.loading.reachMetrics = false;
      this.reachFreqStore.reachMetrics = payload.data;
      this.reachFreqStore.taskIds.reachMetrics = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.frequencyMetrics) {
      this.reachFreqStore.loading.frequencyMetrics = false;
      this.reachFreqStore.frequencyMetrics = payload.data;
      this.reachFreqStore.taskIds.frequencyMetrics = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.mostEffectiveMedium) {
      this.reachFreqStore.loading.mostEffectiveMedium = false;
      this.reachFreqStore.mostEffectiveMedium = payload.data;
      this.reachFreqStore.taskIds.mostEffectiveMedium = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.audienceSize) {
      this.reachFreqStore.loading.audienceSize = false;
      this.reachFreqStore.audienceSize = payload.data;
      this.reachFreqStore.taskIds.audienceSize = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.marketAudienceSize) {
      this.reachFreqStore.loading.marketAudienceSize = false;
      this.reachFreqStore.marketAudienceSize = payload.data;
      this.reachFreqStore.taskIds.marketAudienceSize = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.exposureOverview) {
      this.reachFreqStore.loading.exposureOverview = false;
      this.reachFreqStore.exposureOverview = payload.data;
      this.reachFreqStore.taskIds.exposureOverview = undefined;
      if (!this.reachFreqStore.exposureMarkets && payload.data.markets) {
        this.reachFreqStore.exposureMarkets = {
          total: payload.data.markets?.length,
          markets: payload.data.markets,
          page_size: 5,
          page_number: 1,
        };
      }
    }
    if (payload.id === this.reachFreqStore.taskIds.marketBreakdown) {
      this.reachFreqStore.loading.marketBreakdown = false;
      this.reachFreqStore.marketBreakdown = payload.data.results;
      this.reachFreqStore.taskIds.marketBreakdown = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.reachByDay) {
      this.reachFreqStore.loading.reachByDay = false;
      this.reachFreqStore.reachByDay = payload.data;
      this.reachFreqStore.taskIds.reachByDay = undefined;
    }
    if (payload.id === this.reachFreqStore.taskIds.creativesBreakdown) {
      this.reachFreqStore.loading.creativesBreakdown = false;
      this.reachFreqStore.creativesBreakdown = payload.data.creatives;
      this.reachFreqStore.taskIds.creativesBreakdown = undefined;
    }
  },
};

export const cancelTasks = async () => {
  const reachFreqStore = useReachFreqStore();
  const taskStore = useTaskStore();
  // Abort in-flight PPT export/download so reset/leave cannot still download.
  reachFreqStore.cancelExport();
  const tasks = [
    "dateRange",
    "races",
    "sponsors",
    "networkStations",
    "creatives",
    "reachMetrics",
    "frequencyMetrics",
    "mostEffectiveMedium",
    "exposureOverview",
    "marketBreakdown",
    "reachByDay",
    "creativesBreakdown",
    "audienceSize",
    "marketAudienceSize",
  ];
  const activeTasks = tasks.filter((key) => reachFreqStore.taskIds[key]);
  const cancel = activeTasks.map(async (key) => {
    const taskId = reachFreqStore.taskIds[key];
    await taskStore.cancelTask(taskId);
    reachFreqStore.taskIds[key] = undefined;
    reachFreqStore.loading[key] = false;
  });
  await Promise.all(cancel);
};
